import { cn } from '@/renderer/utils/cn';

const Styles = {
  Button: {
    nav: '[&>*]:group flex flex-wrap text-center text-sm font-medium *:me-3 *:inline-flex *:items-center *:justify-center *:rounded-lg *:px-4 *:py-1',
    item: 'text-inherit hover:bg-zinc-100 dark:hover:bg-zinc-800 dark:bg-zinc-900 hover:text-inherit',
    itemActive: 'bg-zinc-100 dark:bg-zinc-900 text-zinc-900 dark:text-emerald-500',
  },
  Border: {
    nav: '[&>*]:group flex flex-wrap text-center text-sm font-medium sm:text-base *:me-6 *:inline-flex *:items-center *:justify-center *:border-b-2',
    item: 'border-transparent text-inherit hover:border-current hover:text-inherit py-4',
    itemActive: 'border-current text-zinc-900 dark:text-emerald-500',
  },
};

export function FilterTabs<const I extends React.Key | null | undefined>({
  className,
  tabs,
  selected,
  style,
}: {
  tabs: {
    children: JSX.Element | string | JSX.Element[];
    href?: string;
    onClick?: () => unknown;
    id: I;
  }[];
  selected: I | undefined;
  style?: 'button' | 'border';
  className?: string;
}) {
  const styles = style === 'button' ? Styles.Button : Styles.Border;

  return (
    <nav className={cn(styles.nav, className)} role="tablist">
      {tabs.map((tab) => {
        const El = tab.href ? 'a' : 'button';

        return (
          <El
            role="tab"
            href={tab.href}
            onClick={tab.onClick}
            aria-selected={selected === tab.id}
            className={selected === tab.id ? styles.itemActive : styles.item}
            key={tab.id}
          >
            {tab.children}
          </El>
        );
      })}
    </nav>
  );
}
